import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { environment } from '../../environments/environment';
import { extractErrorMessage } from '../utils/utils';

export interface ContactImportUpload {
  headerRows: number;
  batchName: string;
  uploadFile: File | undefined;
  projects: string[];
  events: string[];
}

@Injectable({
  providedIn: 'root',
})
export class UploadService {
  baseUrl: string = environment.api_url;

  constructor(private readonly http: HttpClient) { }

  upload(uploadData: ContactImportUpload) {
    console.debug('upload', uploadData);

    const formData = new FormData();
    formData.append('uploadFile', uploadData.uploadFile!);
    formData.append('headerRows', uploadData.headerRows.toString());
    formData.append('batchName', uploadData.batchName);
    formData.append('projects', new Blob([JSON.stringify(uploadData.projects)], { type: 'application/json' }));
    formData.append('events', new Blob([JSON.stringify(uploadData.events)], { type: 'application/json' }));

    const params = new HttpParams().set('data-type', 'contacts');

    return this.http.post<any>(`${this.baseUrl}/upload`, formData, { params }).pipe(
      catchError(err => throwError(() => extractErrorMessage(err)))
    );
  }
}
